import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaStar, FaWhatsapp } from 'react-icons/fa'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { Services } from '../../../components/index/service/Services'
import { AnimatePresence, motion } from 'framer-motion'
import { getWpNewHouseKeeping, setWpNewHouseKeeping } from '../../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../../lib/service'
import { PartTimeHelperBooking } from '../../../components/index/service-category/domestic-service/PartTimeHelperBooking'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { DeepCleanBooking } from '../../../components/index/service-category/domestic-service/DeepCleanBooking'
import { openModal } from '../../../service/modal-service'
import { SystemError } from '../../../components/error/SystemError'
import { FcGoogle } from "react-icons/fc";
import { FaKitchenSet } from "react-icons/fa6";
import { MdBalcony, MdOutlineBathroom, MdOutlineBedroomParent, MdOutlineLiving } from 'react-icons/md'
import { helperTestimonials } from '../../../data/CustomerReviewData'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { modifiedDate, month, year } = getArticleDateTime()
    const houseKeepingBlogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)

    const currencyCd = "SGD"

    return {
        props: {
            requestCategorySettings,
            modifiedDate,
            month,
            year,
            houseKeepingBlogs,
            currencyCd,
            helperTestimonials,
            wpNewPosts,
            countryName
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}
export default function Home(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const houseKeepingBlogs = props.houseKeepingBlogs
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.helperTestimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Domestic Services'
    const countryName = props.countryName
    const currencyCd = props.currencyCd

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ waInd, setWaInd ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)

    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    useEffect(() => {
        setRequestForm(router.query.requestForm)
    }, [router.query.requestForm])

    const videoRef = useRef();

    useEffect(() => {    
        if(requestForm) return
        videoRef.current.play()
    }, [requestForm])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = () =>{
        setErrorContent({'header': "Service Inclusions", 'isInfo': true, 'body': "All Rooms - Wipe all surfaces, including aircon. Clean windows, frames, and sills. Wipe cabinet interiors and shelves if empty. Clean ceiling fans and light fixtures. Vacuum and mop.\n\nKitchen - Clean sinks, dining tables, walls, kitchen appliances, dispose of garbage bags.\n\nBathrooms - Clean toilet bowls, bathtub/shower, glass surfaces, mirrors, basin, tap, ventilation fan, floor, drains, wall tiles, and door. Wipe racks and drawers if empty. Dispose of garbage bags.\n\nBedrooms - Wipe racks and drawers if empty. Dispose of garbage bags.\n\nOther - Wipe glass windows, metal grilles (if any), and clean washing machine exterior."});
        openModal(setIsSystemError)
    }

  return (
    <>
      <Head>
        <title>Professional Spring Cleaning Service In Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Transform your space with StringsSG Spring Cleaning Services in Singapore. We specialize in deep cleaning, decluttering, and organizing, leaving your home refreshed and ready for a new beginning. Experience top-notch service and usher in the seasons with a pristine living environment. Book today!"/>
        <meta name="keywords" content="Spring Cleaning Service Singapore"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Professional Spring Cleaning Service In Singapore`}/>
        <meta property="og:description" content="Transform your space with StringsSG Spring Cleaning Services in Singapore. We specialize in deep cleaning, decluttering, and organizing, leaving your home refreshed and ready for a new beginning. Experience top-notch service and usher in the seasons with a pristine living environment. Book today!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-21T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning"/>
        <meta name="twitter:title" content={`Professional Spring Cleaning Service In Singapore`}/> 
        <meta name="twitter:description" content="Transform your space with StringsSG Spring Cleaning Services in Singapore. We specialize in deep cleaning, decluttering, and organizing, leaving your home refreshed and ready for a new beginning. Experience top-notch service and usher in the seasons with a pristine living environment. Book today!"/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning"},"headline":"Professional Spring Cleaning Service In Singapore","description":"Transform your space with StringsSG Spring Cleaning Services in Singapore. We specialize in deep cleaning, decluttering, and organizing, leaving your home refreshed and ready for a new beginning. Experience top-notch service and usher in the seasons with a pristine living environment. Book today!","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-21T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore","name":"Part Time Cleaner Singapore","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning","name":"Spring Cleaning","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning"}}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/spring-cleaning"/>
        </Head>
        <section id="professional-house-cleaning-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">
                {/* Mobile Video */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/housekeeping-1920-1080.jpg"}
                    title="Professional House Cleaning Singapore"
                    muted
                    loop
                    playsInline
                    preload="metadata"
                >
                    <source src="/video/part-time-helper-web.mp4" />
                    <source src="/video/part-time-helper-web.mov" />
                </video>

                {/* Desktop Image */}
                <Image
                    src={s3Static + "blog/living/part-time-helper/part-time-cleaners-singapore.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Professional house cleaning in Singapore"
                    priority={false}
                    quality={100}
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                    <DeepCleanBooking requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} deepCleanType="Quick Booking - Home Cleaning" showJobScope={showJobScope} serviceType="Spring cleaning"/>
                </div> 
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
            </RequestProvider>  
        </section>
        <div className='max-w-4xl mx-auto py-10 px-2'>
            <div className='space-y-2 text-center '>
                <h1 className='text-3xl md:text-4xl font-semibold'>Spring Cleaning Singapore</h1>
                {/* <div className='text-gray-400 text-xs'>
                    <time dateTime={modifiedDate}>Updated - {new Date(modifiedDate).toUTCString().substring(0,16)}</time>
                </div>                     */}
                <div className='flex justify-center items-center font-bold text-gray-400 pt-2'>
                    <div> <FcGoogle className='text-3xl' /> </div>
                    <span>&nbsp;Rated 4.9</span>
                    <span className='px-1'>  
                        <FaStar className=' text-amber-300 text-xl'/>
                    </span>
                </div>
            </div>
            <h2 className='text-2xl font-bold text-center pt-10'>What is Spring Cleaning?</h2>
            <div className='py-5'>
                <div className='leading-8 space-y-5'>
                    <p>                        
                    Since there are no distinct seasons in Singapore, the term &quot;Spring cleaning&quot; has no connection to the arrival of spring. As an alternative, 
                    many Singaporeans celebrate spring cleaning as a custom before to the Chinese New Year, which usually takes place in January or February.                            
                    </p>
                    <p>
                    In Singapore, residents celebrate Chinese New Year by meticulously cleaning their homes in an effort to drive off ill luck and make room for good fortune 
                    in the upcoming year. A complete and comprehensive cleaning of the entire house, including dusting, sweeping, mopping, and rearranging, is what spring 
                    cleaning entails.
                    </p>
                    <p>
                    In Singapore, residents celebrate Chinese New Year by meticulously cleaning their homes in an effort to drive off ill luck and make room for good fortune 
                    in the upcoming year. A complete and comprehensive cleaning of the entire house, including dusting, sweeping, mopping, and rearranging, is what spring 
                    cleaning entails.
                    </p>
                    <p>
                    To start the new year with a clean slate and a tidy home, people tidy their houses. It&apos;s said that getting rid of the old and making the house shiny will help 
                    draw luck and good vibes for the new year. Families also frequently use festive decorations for their homes, such red lanterns and banners, since red is seen 
                    as an auspicious hue in Chinese tradition.
                    </p>
                    <p>
                    In addition to being a useful method of keeping things clean, spring cleaning has symbolic and cultural value in Singapore, especially around the Chinese 
                    New Year festivities.
                    </p>
                </div>
                <div className='h-96 relative'>
                    <Image className='rounded-xl'
                        src={s3Static + "blog/living/part-time-helper/Cleaning team with brooms and vacuum cleaner.jpg"}
                        fill
                        style={{objectFit: 'cover'}}
                        alt='Spring Cleaning Singapore'
                        priority="false"
                        quality={100}
                    />
                </div>
                <figcaption className='text-xs italic text-gray-500 text-center py-1'>Cleaners ready for Spring cleaning</figcaption>
            </div> 
        </div>
        <div className='max-w-4xl mx-auto py-10'>
            <h2 className='text-xl md:text-2xl text-center uppercase'>
                <strong>Services Inclusions</strong>
            </h2>
            <div className='mt-10 text-sm leading-7 space-y-5'> 
                <div className='bg-slate-200 px-2 py-10 text-center h-full space-y-5'>
                    <div className='flex justify-center'>
                        <MdOutlineLiving className='text-8xl text-orange-500'/>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='text-base'><strong>Living Area</strong></h3>
                        <p className='mx-auto'>
                        Wipe all surfaces, including aircon exterior. Clean window interiors, frames, and sills. Wipe cabinet interiors and shelves if empty. Clean ceiling fans and standard light fixtures. Vacuum and mop floor area.
                        </p> 
                    </div>
                </div>
                <div className='px-2 py-10 text-center h-full space-y-5'>
                    <div className='flex justify-center'>
                        <MdOutlineBedroomParent className='text-8xl text-orange-500'/>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='text-base'><strong>Bedrooms</strong></h3>
                        <p className='mx-auto'>
                        Wipe all surfaces (including air-con exterior, window interiors, frames, sills, ceiling fans, light fixtures, cabinets, and shelves). Wipe racks and drawers if empty. Dispose of and replace garbage bags. Vacuum and mop floor area.
                        </p> 
                    </div>
                </div>
                <div className='bg-slate-200 px-2 py-10 text-center h-full space-y-5'>
                    <div className='flex justify-center'>
                        <FaKitchenSet className='text-8xl text-orange-500'/>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='text-base'><strong>Kitchen</strong></h3>
                        <p className='mx-auto'>
                        Wipe all surfaces, including empty cabinets, sinks, dining tables, and tiled walls. Clean kitchen appliances, including the refrigerator, stove, cooker hood, and hob. Dispose of and replace garbage bags. Vacuum and mop floor area.
                        </p> 
                    </div>
                </div>
                <div className='px-2 py-10 text-center h-full space-y-5'>
                    <div className='flex justify-center'>
                        <MdOutlineBathroom className='text-8xl text-orange-500'/>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='text-base'><strong>Bathrooms</strong></h3>
                        <p className='mx-auto'>
                        Clean all surfaces, including toilet bowls, bathtub/shower area, glass surfaces, mirrors, basin, tap, ventilation fan, floor, drains, wall tiles, and door. Wipe racks and drawers if empty. Dispose of and replace existing garbage bags.
                        </p> 
                    </div>
                </div>
                <div className='bg-slate-200 px-2 py-10 text-center h-full space-y-5'>
                    <div className='flex justify-center'>
                        <MdBalcony className='text-8xl text-orange-500'/>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='text-base'><strong>Other</strong></h3>
                        <p className='mx-auto'>
                        Mop balcony, wipe glass windows, metal grilles (if any), and clean washing machine exterior.
                        </p> 
                    </div>
                </div>
            </div>
        </div> 
        <div className='max-w-4xl mx-auto my-10 space-y-5 px-2'>
            <h2 className='text-xl md:text-2xl text-center uppercase'><strong>Spring Cleaning Price in Singapore</strong></h2>
            <div className='leading-8'>
                The cost of Spring cleaning service for a 1000 Sqft apartment can cost anywhere between $400 - $600 in Singapore, whereas for a 1500 Sqft apartment it can cost
                $550 - $700. the cost may vary depending on the type of house like, HDB, Condo or Landed house. Different cleaning companies also charge differently as per their 
                price chart.
            </div>
            <div className='leading-8'>
                At StringsSG, the pricing is calculated in a more smarter way which takes into consideration the exact floor size of the house, whereas our competitors use a range
                of square footage to dictate the pricing. StringsSG&apos;s platform also takes into consideration the current market trends based on internal research statistics
                which balance the price based on supply demand.
                Use the StringsSG instant quotation calculator to get the exact pricing for your next Spring cleaning.
            </div>
        </div>
        <div className='h-120 py-10 my-10 relative bg-black'>
            <h2 className='text-2xl md:text-3xl text-center px-2 uppercase text-white absolute left-0 right-0 z-10 top-10'>
                <strong>Why us?</strong>
            </h2>
            <Image className='opacity-40'
                src={s3Static + "blog/living/part-time-helper/indonesian-maid.jpg"}
                fill
                style={{objectFit: 'cover', objectPosition: 'center'}}   
                placeholder='blur'
                blurDataURL={s3Static + "placeholder.png"}
                alt='Affordable Part Time Helper Service - StringsSG'
            /> 
            <div className='text-white py-20 leading-8'>
                <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} interval={5000} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}>
                    <div className='px-6 py-10 h-full'>
                        <h4 className='text-xl'><strong>Instant Booking</strong></h4>
                        <p className='py-5 max-w-3xl mx-auto'>
                            The platform allows for instant booking, providing immediate access to a pool of legal and skilled home cleaners.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h4 className='text-xl'><strong>Best Service Quality</strong></h4>
                        <div className='py-5 max-w-3xl mx-auto'>
                            We have onboarded highly ethical and diligent team of spring cleaning companies on our platform, and have standardized the service quality.
                        </div> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h4 className='text-xl'><strong>Affordable</strong></h4>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Our platform provides you with the best pricing based on a dynamic cost calculation algorithm for your requirements.
                        </p> 
                    </div>
                    <div className='px-6 py-10 h-full'>
                        <h4 className='text-xl'><strong>Customer Service</strong></h4>
                        <p className='py-5 max-w-3xl mx-auto'>
                            Use the live chat feature on the app to initiate conversation with the assigned service team.
                        </p> 
                    </div>
                </Carousel>      
            </div>
        </div> 
        <div className='py-10 max-w-4xl mx-auto space-y-2'>
            <h3 className='text-xl px-2 text-center'><strong>Testimonials</strong></h3>
            <p className='text-center px-2 pb-5'>Hear what people have to say about us.</p>
            <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} interval={5000} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}
                className="border-2 shadow shadow-gray-300 rounded-xl">
                {[...testimonials].map((review, i) =>
                    <div key={i} className="p-4 text-sm leading-6 space-y-2">
                        <h4 className='text-center font-bold'>
                            {review.requestUserFullNm}
                        </h4>
                        <div className='flex justify-center items-center'>
                            <div className={'text-xs text-white px-2 py-1 rounded-full ' + 
                                    (review.rating >= 4 && " bg-green-600 ") +
                                    ((review.rating >= 3 && review.rating < 4) && " bg-blue-600 ") +
                                    ((review.rating >= 2 && review.rating < 3) && " bg-cyan-600 ") +
                                    ((review.rating >= 1 && review.rating < 2) && " bg-amber-500 ") +
                                    ((review.rating > 0 && review.rating < 1) && " bg-red-600 ")                             
                                }                              
                                >
                                {review.rating}
                            </div>
                            <div className="px-1 py-3 flex space-x-1 text-lg">  
                                {[...maxRating].map((star, x) =>                             
                                    <div key={x} className="relative">
                                        <FaStar className=' text-gray-300'/>
                                        {x < review.rating  &&
                                        <div className=''>
                                            <FaStar className='text-amber-300' style={{marginTop: "-18px"}}/>
                                        </div>
                                        }
                                    </div>                        
                                )}
                            </div>
                        </div>
                        <p className='pb-10 px-4 wrap-break-word whitespace-pre-wrap max-h-80 overflow-y-auto scrollbar-hide'>
                            {review.reviewComment}
                        </p>
                    </div>
                )}
            </Carousel>
        </div>
        <div className='max-w-5xl mx-auto text-center py-10 relative'>
            <div className='relative w-full h-96'>
                <Image
                    src={s3Static + "blog/living/part-time-helper/cleaner-with-toilet-cleaning-bucket.jpg"}
                    fill
                    style={{objectFit: 'cover', objectPosition: 'right'}} 
                    placeholder='blur'
                    blurDataURL={s3Static + "placeholder.png"}
                    alt='Domestic helper service Singapore - StringsSG'
                />     
            </div> 
            <div className='absolute flex items-center text-white top-0 bottom-0 left-0 right-0 w-fit mx-auto rounded-3xl'>
                <Link href="/sg/part-time-cleaner-singapore" prefetch={false} className='p-4 rounded-lg bg-black/60 text-xl md:text-2xl'>
                    Book Part Time Cleaner
                </Link>       
            </div>  
        </div>     
        <div className='fixed bottom-2 w-full text-center z-10 flex justify-center space-x-5'>
            {/* <a href={waInd ? "https://wa.me/6593512695" : "https://wa.me/6588491419" } target="_blank" rel="noreferrer" className='flex items-center text-white py-2 px-4 rounded-full bg-gradient-to-tl from-green-700 to-green-500 font-bold space-x-1'>
                <div>Chat</div>
                <FaWhatsapp className='text-2xl'/>
            </a> */}
        </div>  
        <BlogsList blogs={houseKeepingBlogs} wpPosts={[]} wpNewPosts={wpNewPosts}/>     
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}